module.exports = __webpack_public_path__ + "img/logo_old.f4157b81.png";